import { useCallback } from "react";
import { eventsApi } from "@/lib/humhub-api/events";

interface FetchReminderOptions {
  signal: AbortSignal;
}

interface FetchEntryOptions {
  signal: AbortSignal;
}

export const useEventEmailTemplates = () => {
  const fetchReminderTemplate = useCallback(
    (eventId: number, reminderId: number, options?: FetchReminderOptions) =>
      eventsApi.fetchCustomReminderTemplate(eventId, reminderId, options),
    [],
  );

  const fetchEntryEmailTemplate = useCallback(
    (eventId: number, options?: FetchEntryOptions) =>
      eventsApi.fetchEntryEmailTemplate(eventId, options),
    [],
  );

  return {
    fetchReminderTemplate,
    fetchEntryEmailTemplate,
  };
};
